import styled, { css } from 'styled-components'
import { ReactComponent as ChevronDownIcon } from 'libs/shared/assets/src/lib/icons/arrows/arrDown.svg'
import { ReactComponent as HelpCircle } from 'libs/shared/assets/src/lib/icons/dataplace/help-circle.svg'
import { ReactComponent as RobotIcon } from 'libs/shared/assets/src/lib/icons/robot.svg'

export const Wrapper = styled.div<{$isPrinting: boolean}>(({
  theme: { palette }, $isPrinting,
}) => css`
  display: flex;
  flex-direction: column;
  background-color: ${palette.product.overview.background};
  border: 1px solid ${palette.product.overview.border};
  padding: ${$isPrinting ? '0.5rem' : '2rem'};
  border-radius: 20px;
  gap: 1rem;
  
  ${$isPrinting && css`
    width: fit-content;
  `}
`)

export const HeaderBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const LLMSummaryHeader = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`

export const OverviewWrapper = styled.div<{$contentWidth?: string, $isPrinting?: boolean}>`
  display: flex;
  flex-direction: column;
  gap: ${({ $isPrinting }) => ($isPrinting ? '0.25rem' : '1rem')};
  align-items: center;
  margin: 0 auto;
  width: ${({ $contentWidth }) => $contentWidth ?? 'fit-content'};
  --overview-content-width: ${({ $contentWidth }) => $contentWidth ?? 'fit-content'};
`

export const LLMSummaryWrapper = styled.div(({
  theme: {
    palette, corners,
  },
}) => css`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: ${palette.light.white};
  padding: 1.5rem;
  border: 1px solid ${palette.gray.light};
  border-radius: ${corners.overview.borderRadius};
  box-sizing: border-box;
  align-self: center;
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
  width: var(--overview-content-width, 100%);
`)

export const LLMSummaryBadge = styled.div<{$isPrinting?: boolean}>(({
  $isPrinting = false,
  theme: {
    palette, typography,
  },
}) => css`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: ${palette.product.overview.main};
  background-color: ${palette.product.overview.background};
  border: 1px solid ${palette.product.overview.border};
  border-radius: ${$isPrinting ? 5 : 9}px;
  padding: ${$isPrinting ? '0.1rem 0.2rem' : '0.375rem 0.75rem'};
  font-size: ${$isPrinting ? typography.tiny.pt_10_medium.fontSize : typography.tiny.pt_12_medium.fontSize};
  font-weight: ${$isPrinting ? typography.tiny.pt_10_medium.fontWeight : typography.tiny.pt_12_medium.fontWeight};
  line-height: ${$isPrinting ? typography.tiny.pt_10_medium.lineHeight : typography.tiny.pt_12_medium.lineHeight};
  width: fit-content;
`)

export const LLMSummaryBadgeIcon = styled(RobotIcon)`
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;

  path {
    fill: currentColor;
  }
`

export const StyledHelpCircle = styled(HelpCircle)(({ theme: { palette } }) => css`
  cursor: pointer;
  min-width: 1rem;
  width: 1rem;

  > path {
    fill: ${palette.product.overview.main};
  }
`)

export const TitleBox = styled.div(({ theme: { palette } }) => css`
  display: flex;
  color: ${palette.product.overview.main};
  gap: 0.5rem;
  align-items: center;
`)

export const Chevron = styled(ChevronDownIcon)<{$isOpened: boolean}>(({
  theme: { palette }, $isOpened,
}) => css`
  cursor: pointer;
  background-color: ${palette.light.white};
  padding: 1rem;
  border-radius: 20px;
  transform: rotate(${$isOpened ? '180deg' : '0deg'});
  path {
      stroke: ${palette.product.overview.main};
    }
`)

export const OverviewContent = styled.div<{$isPrinting?: boolean}>(({ $isPrinting = false }) => css`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: ${$isPrinting ? '0.25rem' : '1rem'};
  width: var(--overview-content-width, fit-content);
`)

export const OverviewColumn = styled.div<{$width?: string, $isPrinting?: boolean}>(({
  $width, $isPrinting = false,
}) => css`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  ${$width
    ? css`
      width: ${$width};
    `
    : css`
      min-width: 403px;
      max-width: 503px;
    `
}

  ${$isPrinting && css`
    min-width: unset;
    max-width: unset;
    width: fit-content;
    gap: 0.25rem;
  `}
`)

export const StyledOverlay = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  filter: blur(5px);
  pointer-events: none;
  user-select: none;
  * {
    pointer-events: none !important;
  }
`

export const OverlayTopWrapper = styled.div`
  align-self: center;
  width: fit-content;
`

export const OverlayMessage = styled.div(({
  theme: {
    palette, typography,
  },
}) => css`
  font-size: ${typography.main.pt_15_medium.fontSize};
  font-weight: ${typography.main.pt_15_medium.fontWeight};
  line-height: ${typography.main.pt_15_medium.lineHeight};
  color: ${palette.results.red.dark};
  background-color: ${palette.results.red.opaque};
  border: 1px solid ${palette.results.red.light};
  padding: 0.75rem 1rem;
  border-radius: 12px;
  text-align: center;
  max-width: 520px;
`)
